import React, {Component} from 'react';
import {action, observable} from 'mobx';
import {inject, observer} from 'mobx-react';
import {Button, FormInput, FormCheckbox, FormSelect, Modal, ModalHeader, ModalBody, ModalFooter} from 'shards-react';
import FeatherIcon from 'feather-icons-react';
import {toast} from 'react-toastify';
import moment from 'moment';
import PageTitle from '../../../components/common/PageTitle';
import './superConfigPayment.scss';

const PLAN_FIELD_DEFS = {
  payTypeFirst: {
    title: '신규 고객 결제 옵션 (payTypeFirst)',
    desc: '14일 무료, 신규 할인 폭탄 등 첫 결제 화면 아코디언/옵션에 노출되는 항목',
    columns: [
      {key: 'val', label: 'val', width: 130},
      {key: 'label', label: '라벨(노출 텍스트)', width: 240},
      {key: 'type', label: 'type', width: 110, type: 'select', options: ['free', 'event', 'autoPayment']},
      {key: 'period', label: '기간(개월/일)', width: 110, type: 'number'},
      {key: 'freePeriod', label: '무료 기간', width: 100, type: 'number'},
      {key: 'eventClass', label: 'eventClass', width: 110},
      {key: 'eventName', label: 'eventName', width: 210}
    ]
  },
  payType: {
    title: '기본 결제 옵션 (payType)',
    desc: '월 정기결제 / 1년 일시불 등 기본 플랜 영역에 노출되는 항목',
    columns: [
      {key: 'val', label: 'val', width: 140},
      {key: 'label', label: '라벨(노출 텍스트)', width: 240},
      {key: 'type', label: 'type', width: 110, type: 'select', options: ['autoPayment', 'discount', 'event']},
      {key: 'period', label: '기간(개월)', width: 100, type: 'number'},
      {key: 'discountPer', label: '할인율(%)', width: 100, type: 'number'},
      {key: 'freePeriod', label: '무료 기간', width: 100, type: 'number'},
      {key: 'eventClass', label: 'eventClass', width: 110},
      {key: 'eventName', label: 'eventName', width: 210}
    ]
  },
  planPd: {
    title: '플랜 상품 (planPd)',
    desc: '월평균 주문 수에 따라 자동 책정되는 플랜 상품 (R-1000, R-2000 등)',
    columns: [
      {key: 'val', label: 'val', width: 130},
      {key: 'name', label: 'name', width: 130},
      {key: 'label', label: '라벨', width: 260},
      {key: 'orgPrice', label: '원가(원)', width: 110, type: 'number'},
      {key: 'price', label: '판매가(원)', width: 110, type: 'number'},
      {key: 'orderCountLte', label: '주문수 ≤', width: 110, type: 'number'}
    ]
  }
};

@inject(({teamUser}) => ({isLogin: teamUser.isLogin, me: teamUser.me}))
@inject(({AOA}) => ({
  getSuperConfigPaymentList: AOA.getSuperConfigPaymentList,
  upsertSuperConfigPayment: AOA.upsertSuperConfigPayment,
  deleteSuperConfigPayment: AOA.deleteSuperConfigPayment
}))
@observer
class SuperConfigPayment extends Component {
  @observable isLoading = true;
  @observable list = [];
  @observable selectedId = null;
  @observable editing = null;
  @observable isSaving = false;
  @observable addRowSection = null;
  @observable addRowKey = '';
  @observable confirmDelete = {open: false};

  componentDidMount() {
    this.fetchList();
  }

  @action
  fetchList = () => {
    this.isLoading = true;
    this.props.getSuperConfigPaymentList((res) => {
      this.isLoading = false;
      const items = (res && res.data && res.data.items) || [];
      this.list = items;
      if (!this.selectedId && items.length > 0) {
        this.selectedId = items[0]._id;
        this.editing = this.normalize(items[0]);
      }
    });
  };

  normalize = (doc) => {
    const boosterAddOn = doc.boosterAddOn ? JSON.parse(JSON.stringify(doc.boosterAddOn)) : {};
    // 공통 할인율(discountPer)만 있는 기존 문서 — 정기/일시불 필드로 이관
    if (boosterAddOn.discountPer !== undefined && boosterAddOn.discountPerAuto === undefined && boosterAddOn.discountPerOnce === undefined) {
      boosterAddOn.discountPerAuto = boosterAddOn.discountPer;
      boosterAddOn.discountPerOnce = boosterAddOn.discountPer;
    }
    return {
      _id: doc._id,
      isDev: !!doc.isDev,
      version: typeof doc.version === 'number' ? doc.version : null,
      payTypeFirst: doc.payTypeFirst ? JSON.parse(JSON.stringify(doc.payTypeFirst)) : {},
      payType: doc.payType ? JSON.parse(JSON.stringify(doc.payType)) : {},
      planPd: doc.planPd ? JSON.parse(JSON.stringify(doc.planPd)) : {},
      boosterAddOn: boosterAddOn,
      updatedAt: doc.updatedAt,
      createdAt: doc.createdAt
    };
  };

  @action
  selectDoc = (doc) => {
    this.selectedId = doc._id;
    this.editing = this.normalize(doc);
  };

  @action
  newDoc = () => {
    this.selectedId = null;
    this.editing = {
      _id: null,
      isDev: true,
      version: 2,
      payTypeFirst: {},
      payType: {},
      planPd: {},
      boosterAddOn: {}
    };
  };

  @action
  onChangeMeta = (field, value) => {
    if (!this.editing) return;
    if (field === 'isDev') this.editing.isDev = !!value;
    else if (field === 'version') this.editing.version = value === '' ? null : Number(value);
  };

  @action
  onChangeRow = (section, rowKey, colKey, value, type) => {
    if (!this.editing) return;
    const row = this.editing[section][rowKey];
    if (!row) return;
    if (type === 'number') {
      row[colKey] = value === '' ? '' : Number(value);
    } else {
      row[colKey] = value;
    }
  };

  @action
  onChangeBooster = (key, value, type) => {
    if (!this.editing) return;
    if (!this.editing.boosterAddOn) this.editing.boosterAddOn = {};
    if (type === 'number') {
      this.editing.boosterAddOn[key] = value === '' ? '' : Number(value);
    } else {
      this.editing.boosterAddOn[key] = value;
    }
  };

  @action
  removeRow = (section, rowKey) => {
    if (!this.editing) return;
    delete this.editing[section][rowKey];
  };

  @action
  openAddRow = (section) => {
    this.addRowSection = section;
    this.addRowKey = '';
  };

  @action
  closeAddRow = () => {
    this.addRowSection = null;
    this.addRowKey = '';
  };

  @action
  confirmAddRow = () => {
    const key = (this.addRowKey || '').trim();
    if (!key) {
      toast.error('새 항목의 키(key)를 입력해주세요.');
      return;
    }
    if (this.editing[this.addRowSection][key]) {
      toast.error('이미 존재하는 키입니다.');
      return;
    }
    const def = PLAN_FIELD_DEFS[this.addRowSection];
    const blank = {};
    for (const c of def.columns) blank[c.key] = c.type === 'number' ? 0 : '';
    blank.val = key;
    this.editing[this.addRowSection][key] = blank;
    this.closeAddRow();
  };

  @action
  save = () => {
    if (!this.editing) return;
    if (this.isSaving) return;
    this.isSaving = true;

    const payload = {
      _id: this.editing._id || undefined,
      payTypeFirst: this.editing.payTypeFirst,
      payType: this.editing.payType,
      planPd: this.editing.planPd,
      boosterAddOn: this.editing.boosterAddOn || {},
      isDev: !!this.editing.isDev,
      version: typeof this.editing.version === 'number' ? this.editing.version : undefined
    };

    this.props.upsertSuperConfigPayment(payload, (res) => {
      this.isSaving = false;
      if (res && res.data && res.data.error) {
        toast.error(res.data.error.message || '저장에 실패했습니다.');
        return;
      }
      const item = res && res.data && res.data.item;
      if (item) {
        toast.success('요금제 플랜이 저장되었습니다.');
        this.selectedId = item._id;
        this.fetchList();
      } else {
        toast.error('알 수 없는 오류로 저장되지 않았습니다.');
      }
    });
  };

  @action
  askDelete = () => {
    if (!this.editing || !this.editing._id) {
      toast.error('삭제할 문서를 먼저 선택해주세요.');
      return;
    }
    this.confirmDelete = {open: true};
  };

  @action
  doDelete = () => {
    const id = this.editing && this.editing._id;
    if (!id) return;
    this.confirmDelete = {open: false};
    this.props.deleteSuperConfigPayment({_id: id}, (res) => {
      if (res && res.data && res.data.error) {
        toast.error(res.data.error.message || '삭제 실패');
        return;
      }
      if (res && res.data && res.data.deleted) {
        toast.success('삭제되었습니다.');
        this.selectedId = null;
        this.editing = null;
        this.fetchList();
      } else {
        toast.error('삭제 결과를 확인할 수 없습니다.');
      }
    });
  };

  renderSectionTable = (section) => {
    if (!this.editing) return null;
    const def = PLAN_FIELD_DEFS[section];
    const rows = Object.keys(this.editing[section]);

    return (
      <div className="scp-section" key={section}>
        <div className="scp-section__head">
          <div>
            <h3 className="scp-section__title">{def.title}</h3>
            <p className="scp-section__desc">{def.desc}</p>
          </div>
          <Button size="sm" theme="primary" onClick={() => this.openAddRow(section)}>
            <FeatherIcon icon="plus" size="13"/> 항목 추가
          </Button>
        </div>
        <div className="scp-table-wrap">
          <table className="scp-table">
            <thead>
              <tr>
                <th style={{width: 140}}>key</th>
                {def.columns.map((c) => (
                  <th key={c.key} style={{width: c.width || 'auto'}}>{c.label}</th>
                ))}
                <th style={{width: 60}}></th>
              </tr>
            </thead>
            <tbody>
              {rows.length === 0 && (
                <tr>
                  <td colSpan={def.columns.length + 2} className="scp-empty">항목이 없습니다.</td>
                </tr>
              )}
              {rows.map((rowKey) => {
                const row = this.editing[section][rowKey];
                return (
                  <tr key={rowKey}>
                    <td className="scp-key">{rowKey}</td>
                    {def.columns.map((c) => (
                      <td key={c.key}>
                        {c.type === 'select' ? (
                          <FormSelect value={row[c.key] || ''}
                                      onChange={(e) => this.onChangeRow(section, rowKey, c.key, e.target.value)}>
                            <option value="">-</option>
                            {(c.options || []).map((o) => (<option key={o} value={o}>{o}</option>))}
                          </FormSelect>
                        ) : (
                          <FormInput type={c.type === 'number' ? 'number' : 'text'}
                                     value={row[c.key] === undefined || row[c.key] === null ? '' : row[c.key]}
                                     onChange={(e) => this.onChangeRow(section, rowKey, c.key, e.target.value, c.type)}/>
                        )}
                      </td>
                    ))}
                    <td>
                      <button type="button" className="scp-row-del"
                              onClick={() => this.removeRow(section, rowKey)}
                              title="이 항목 삭제">
                        <FeatherIcon icon="trash-2" size="14"/>
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  renderBoosterSection = () => {
    if (!this.editing) return null;
    const booster = this.editing.boosterAddOn || {};
    const price = Number(booster.price) > 0 ? Number(booster.price) : 10000;
    const perAuto = Number(booster.discountPerAuto) || 0;
    const perOnce = Number(booster.discountPerOnce) || 0;
    const now = moment();
    const start = booster.discountStartDate ? moment(booster.discountStartDate) : null;
    const end = booster.discountEndDate ? moment(booster.discountEndDate).endOf('day') : null;
    const isInPeriod = (!start || now.isSameOrAfter(start)) && (!end || now.isSameOrBefore(end));
    const fmt = (n) => new Intl.NumberFormat('ko-KR').format(n);
    const preview = (per) => per > 0 ? (
      <>
        {fmt(price)}원 → <strong>{fmt(Math.floor(price * (100 - per) / 100))}원</strong> ({per}% 할인
        {isInPeriod ? ' — 현재 적용중' : ' — 현재 할인 기간 아님(정상가 적용)'})
      </>
    ) : (
      <>{fmt(price)}원 (할인 없음)</>
    );

    return (
      <div className="scp-section">
        <div className="scp-section__head">
          <div>
            <h3 className="scp-section__title">리뷰 부스터 애드온 (boosterAddOn)</h3>
            <p className="scp-section__desc">결제 페이지의 리뷰 부스터 추가 옵션 단가·할인율·할인 기간을 설정합니다. 정기결제와 일시불 결제의 할인율을 각각 설정할 수 있으며, 할인 기간을 비워두면 상시 할인으로 적용됩니다.</p>
          </div>
        </div>
        <div className="scp-meta">
          <div className="scp-meta__row">
            <label className="scp-meta__label">월 단가(원)</label>
            <FormInput type="number" value={booster.price === undefined || booster.price === null ? '' : booster.price}
                       placeholder="10000"
                       onChange={(e) => this.onChangeBooster('price', e.target.value, 'number')}
                       style={{maxWidth: 140}}/>
            <span className="scp-meta__hint">미입력 시 기본 10,000원</span>
          </div>
          <div className="scp-meta__row">
            <label className="scp-meta__label">정기결제 할인율(%)</label>
            <FormInput type="number" value={booster.discountPerAuto === undefined || booster.discountPerAuto === null ? '' : booster.discountPerAuto}
                       placeholder="0"
                       onChange={(e) => this.onChangeBooster('discountPerAuto', e.target.value, 'number')}
                       style={{maxWidth: 140}}/>
            <span className="scp-meta__hint">월 정기결제(autoPayment)에 적용 · 0이면 할인 미적용</span>
          </div>
          <div className="scp-meta__row">
            <label className="scp-meta__label">일시불 할인율(%)</label>
            <FormInput type="number" value={booster.discountPerOnce === undefined || booster.discountPerOnce === null ? '' : booster.discountPerOnce}
                       placeholder="0"
                       onChange={(e) => this.onChangeBooster('discountPerOnce', e.target.value, 'number')}
                       style={{maxWidth: 140}}/>
            <span className="scp-meta__hint">일시불(할인/이벤트) 결제에 적용 · 0이면 할인 미적용</span>
          </div>
          <div className="scp-meta__row">
            <label className="scp-meta__label">할인 시작일</label>
            <FormInput type="date" value={booster.discountStartDate || ''}
                       onChange={(e) => this.onChangeBooster('discountStartDate', e.target.value)}
                       style={{maxWidth: 180}}/>
          </div>
          <div className="scp-meta__row">
            <label className="scp-meta__label">할인 종료일</label>
            <FormInput type="date" value={booster.discountEndDate || ''}
                       onChange={(e) => this.onChangeBooster('discountEndDate', e.target.value)}
                       style={{maxWidth: 180}}/>
            <span className="scp-meta__hint">종료일 당일까지 할인 적용 · 정기/일시불 공통</span>
          </div>
          <div className="scp-meta__row">
            <label className="scp-meta__label">미리보기 — 정기</label>
            <span className="scp-meta__val">{preview(perAuto)}</span>
          </div>
          <div className="scp-meta__row">
            <label className="scp-meta__label">미리보기 — 일시불</label>
            <span className="scp-meta__val">{preview(perOnce)}</span>
          </div>
        </div>
      </div>
    );
  };

  render() {
    return (
      <div className="main-content">
        <PageTitle/>
        <div className="scp-page">
          <div className="scp-header">
            <div>
              <h2 className="scp-header__title">요금제 플랜 관리</h2>
              <p className="scp-header__desc">SuperConfig <code>type=payment</code> 문서를 관리합니다. 결제 페이지의 플랜·할인·이벤트 옵션이 이 데이터를 기반으로 노출됩니다.</p>
            </div>
            <div className="scp-header__actions">
              <Button theme="light" size="sm" onClick={this.fetchList} disabled={this.isLoading}>
                <FeatherIcon icon="refresh-cw" size="13"/> 새로고침
              </Button>
              <Button theme="primary" size="sm" onClick={this.newDoc}>
                <FeatherIcon icon="plus-circle" size="13"/> 새 문서
              </Button>
            </div>
          </div>

          <div className="scp-layout">
            <aside className="scp-list">
              <div className="scp-list__head">문서 목록 ({this.list.length})</div>
              {this.isLoading && <div className="scp-list__loading">불러오는 중...</div>}
              {!this.isLoading && this.list.length === 0 && (
                <div className="scp-list__empty">등록된 문서가 없습니다.</div>
              )}
              {this.list.map((doc) => (
                <button type="button" key={doc._id}
                        className={'scp-list__item' + (this.selectedId === doc._id ? ' is-active' : '')}
                        onClick={() => this.selectDoc(doc)}>
                  <div className="scp-list__item-tags">
                    <span className={'scp-tag scp-tag--' + (doc.isDev ? 'dev' : 'prod')}>
                      {doc.isDev ? 'DEV' : 'PROD'}
                    </span>
                    {typeof doc.version === 'number' && (
                      <span className="scp-tag scp-tag--ver">v{doc.version}</span>
                    )}
                  </div>
                  <div className="scp-list__item-id">{doc._id}</div>
                  <div className="scp-list__item-meta">
                    {doc.updatedAt ? moment(doc.updatedAt).format('YYYY.MM.DD HH:mm') : '—'}
                  </div>
                </button>
              ))}
            </aside>

            <section className="scp-editor">
              {!this.editing && (
                <div className="scp-editor__empty">
                  <FeatherIcon icon="inbox" size="20"/>
                  <span>좌측에서 문서를 선택하거나 새 문서를 만들어주세요.</span>
                </div>
              )}
              {this.editing && (
                <>
                  <div className="scp-meta">
                    <div className="scp-meta__row">
                      <label className="scp-meta__label">_id</label>
                      <span className="scp-meta__val">{this.editing._id || <em>(신규 — 저장 시 발급)</em>}</span>
                    </div>
                    <div className="scp-meta__row">
                      <label className="scp-meta__label">버전(version)</label>
                      <FormInput type="number" value={this.editing.version === null ? '' : this.editing.version}
                                 onChange={(e) => this.onChangeMeta('version', e.target.value)}
                                 placeholder="예: 1, 2"
                                 style={{maxWidth: 120}}/>
                      <span className="scp-meta__hint">결제 페이지는 version=2 문서를 기본 사용합니다.</span>
                    </div>
                    <div className="scp-meta__row">
                      <label className="scp-meta__label">DEV 모드</label>
                      <FormCheckbox toggle small checked={this.editing.isDev}
                                    onChange={() => this.onChangeMeta('isDev', !this.editing.isDev)}>
                        {this.editing.isDev ? 'DEV (운영 미반영)' : 'PROD (운영 반영)'}
                      </FormCheckbox>
                    </div>
                  </div>

                  {this.renderSectionTable('payTypeFirst')}
                  {this.renderSectionTable('payType')}
                  {this.renderSectionTable('planPd')}
                  {this.renderBoosterSection()}

                  <div className="scp-footer-actions">
                    {this.editing._id && (
                      <Button theme="danger" size="sm" outline onClick={this.askDelete}>
                        <FeatherIcon icon="trash-2" size="13"/> 이 문서 삭제
                      </Button>
                    )}
                    <Button theme="primary" size="sm" onClick={this.save} disabled={this.isSaving}>
                      <FeatherIcon icon="save" size="13"/> {this.isSaving ? '저장 중...' : '저장'}
                    </Button>
                  </div>
                </>
              )}
            </section>
          </div>
        </div>

        {/* 항목 추가 모달 */}
        <Modal open={!!this.addRowSection} toggle={() => {}}>
          <ModalHeader toggle={this.closeAddRow}>새 항목 추가</ModalHeader>
          <ModalBody>
            <p className="scp-modal-desc">
              {this.addRowSection ? PLAN_FIELD_DEFS[this.addRowSection].title : ''} 에 추가할 항목의 <strong>key</strong>를 입력해주세요.
              (예: <code>r3000</code>, <code>discount_year</code>, <code>event_4p2_first</code>)
            </p>
            <FormInput value={this.addRowKey} placeholder="key 입력"
                       onChange={(e) => { this.addRowKey = e.target.value; }}/>
          </ModalBody>
          <ModalFooter>
            <Button theme="light" size="sm" onClick={this.closeAddRow}>취소</Button>
            <Button theme="primary" size="sm" onClick={this.confirmAddRow}>추가</Button>
          </ModalFooter>
        </Modal>

        {/* 삭제 확인 모달 */}
        <Modal open={this.confirmDelete.open} toggle={() => { this.confirmDelete = {open: false}; }}>
          <ModalHeader toggle={() => { this.confirmDelete = {open: false}; }}>문서 삭제</ModalHeader>
          <ModalBody>
            이 SuperConfig 문서를 정말 삭제하시겠습니까? 이 작업은 되돌릴 수 없습니다.
          </ModalBody>
          <ModalFooter>
            <Button theme="light" size="sm" onClick={() => { this.confirmDelete = {open: false}; }}>취소</Button>
            <Button theme="danger" size="sm" onClick={this.doDelete}>삭제</Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

export default SuperConfigPayment;
